import api from '@pray/shared/utils/api';

export type ReactivateMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
};

export const reactivateMarketingCampaign = async ({ artistId, campaignId }: ReactivateMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/reactivate`;

  const response = await api.executePostRequest(url, {});

  return response.data;
};
